module.exports = __webpack_public_path__ + "img/img11.62a94947.svg";